"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const hooks_1 = require("common/hooks");
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const react_hook_form_1 = require("react-hook-form");
const schemaComponents_1 = require("@/schemaComponents");
const schema_1 = __importDefault(require("./schema"));
function FindReplaceForm({ readOnly, onSearch, onReplace, onIgnore, onReplaceValueChange, matchedScripts, }) {
    const { handleSubmit, control, formState, watch } = (0, react_hook_form_1.useForm)({
        defaultValues: {
            target: "",
            searchValue: "",
            replaceValue: "",
        },
    });
    const hasErrors = Object.keys(formState.errors).length > 0;
    const target = watch("target");
    const searchValue = (0, hooks_1.useDebounceValue)(watch("searchValue"));
    const replaceValue = (0, hooks_1.useDebounceValue)(watch("replaceValue"));
    const handleReplace = (data) => {
        onReplace(data);
    };
    (0, react_1.useEffect)(() => {
        onSearch(searchValue, target);
    }, [searchValue, target]);
    (0, react_1.useEffect)(() => {
        onReplaceValueChange(replaceValue);
    }, [replaceValue, target]);
    return (react_1.default.createElement("form", { onSubmit: handleSubmit(handleReplace), className: "adjust-width-expand", noValidate: true },
        react_1.default.createElement(schemaComponents_1.Field, { control: control, schema: (0, schema_1.default)(), readOnly: readOnly }),
        !readOnly && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("hr", null),
            hasErrors && react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger" }, "Error while replacing"),
            react_1.default.createElement("div", null,
                react_1.default.createElement(react_bootstrap_1.Button, { type: "submit", className: "me-2", disabled: matchedScripts.length === 0 }, "\u7F6E\u63DB"),
                react_1.default.createElement(react_bootstrap_1.Button, { onClick: onIgnore, type: "button", className: "me-2", variant: "outline-primary", disabled: hasErrors || matchedScripts.length <= 1 }, "\u7121\u8996"))))));
}
exports.default = FindReplaceForm;
